import { toTitleCase } from '@vrplatform/utils';

export function formatPaymentLineType({
  type: lineType,
  description,
}: {
  type: string | null | undefined;
  description?: string | null | undefined;
}) {
  const type = lineType ?? '-';

  const hasApp = type.includes('_');
  const [app, ...line] = type.split('_');

  return {
    app: hasApp ? toTitleCase(app) : undefined,
    line: description?.trim() || toTitleCase(line.join('_') || app),
    full: toTitleCase(type),
  };
}
